import React, { useState, useRef } from "react";
import "../ContactUs/ContactUs.css";
import { Toast } from "primereact/toast";
import axios from "axios";
import TranslationFile from "../Translation/Translation_corp.json";
import config from "../../Configuration/Config";
import FAQSection from "./FAQSection";

let userSelectedLanguage;
export default function ContactUs() {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  let userTimeZone = localStorage.getItem("userTimeZone");
  const [nameValue, setNameValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [numberValue, setNumberValue] = useState("");
  const [messageValue, setMessageValue] = useState("");
  const [file, setFile] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  function handleFile(event) {
    setFile(event.target.files);
  }

  const toast = useRef(null);
  const inputFieldsOnBlur = (e, fieldName) => {
    let value = e.target.value;

    switch (fieldName) {
      case "name":
        setNameValue(value);
        break;

      case "email":
        setEmailValue(value);
        break;

      case "contact":
        setNumberValue(value);
        break;

      case "message":
        setMessageValue(value);
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget.form;
    if (
      nameValue.trim().length == 0 ||
      emailValue.trim().length == 0 ||
      messageValue.trim().length == 0
    ) {
      toast.current.clear();
      toast.current.show({
        severity: "warn",
        summary: TranslationFile.ToastWarningHeader[userSelectedLanguage],
        detail: TranslationFile.FillMandatryFields[userSelectedLanguage]
      });
    } else {
      let fileSizeInBytes = 0;
      if (file != "") {
        for (let i = 0; i < file.length; i++) {
          fileSizeInBytes = fileSizeInBytes + file[i].size;
        }
        // fileSizeInBytes = file.size;
      }
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      const fileSizeInMegabytes = fileSizeInKilobytes / 1024;
      if (fileSizeInMegabytes <= 2) {
        setSubmitBtnLoading(true);
        try {
          let sendEmailObject = {
            emailType: "contactUs",
            contactMail: emailValue,
            status: "New",
            noOfAttempts: 0,
            message: messageValue,
            userName: nameValue,
            contactNumber: numberValue
            // filename: file.name,
          };

          const url = "/emailQueueController/insertEmailQueueAndSendMail";
          const formData = new FormData();
          const objString = JSON.stringify(sendEmailObject);

          // formData.append("file", file);
          for (let i = 0; i < file.length; i++) {
            formData.append("file", file[i]);
          }
          formData.append("request", objString);
          const config = {
            headers: {
              "content-type": "multipart/form-data,application/json",
              timeZone: userTimeZone,
              language: userSelectedLanguage
            }
          };

          axios.post(url, formData, config).then((response) => {
            if (response.data) {
              toast.current.show({
                severity: "success",
                summary: TranslationFile.SuccessText[userSelectedLanguage],
                detail:
                  TranslationFile.ContactSubmitReplyt[userSelectedLanguage],
                sticky: true
              });
              setSubmitBtnLoading(false);
              setTimeout(() => {
                toast.current.clear();
                form?.reset();
                setNameValue("");
                setEmailValue("");
                setNumberValue("");
                setMessageValue("");
                setFile([]);
              }, 5000);
            }
          });
        } catch {}
      } else {
        toast.current.show({
          severity: "warn",
          summary: TranslationFile.ToastWarningHeader[userSelectedLanguage],
          detail:
            TranslationFile.ContactUsFileSizeWarningMsg[userSelectedLanguage] +
            config.ContactUs.uploadFileSizeLimit +
            " MB",
          sticky: true,
          life: 2000
        });
      }
      setFile("");
    }
  };

  return (
    <div className="contact-faq-whole">
      <div className="contact-container">
        <div className="our-contact-form">
          <div className="corp-form">
            <span className="circle one"></span>
            <span className="circle two"></span>

            <form onSubmit={handleSubmit} className="contact-us-form">
              <Toast
                ref={toast}
                position="top-right"
                style={{ marginTop: "80px" }}
              />
              <center>
                <h3 className="home-contact-title">
                  {" "}
                  {TranslationFile.ContactUsHeader[userSelectedLanguage]}
                </h3>
                <br></br>
                <div className="contact-us-form-inside">
                  <input
                    type="text"
                    name="rblname"
                    placeholder={
                      TranslationFile.ContactUsName[userSelectedLanguage]
                    }
                    className="contact-Name-User"
                    autocomplete="off"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        TranslationFile.pleaseFillOutTheFields[
                          userSelectedLanguage
                        ]
                      )
                    }
                    onInput={(e) => e.target.setCustomValidity("")}
                    onBlur={(e) => inputFieldsOnBlur(e, "name")}
                  />
                  <br></br>
                  <br></br>

                  <input
                    type="email"
                    name="rblemail"
                    placeholder={
                      TranslationFile.ContactUsEmail[userSelectedLanguage]
                    }
                    className="contact-Email-User"
                    autocomplete="new-password"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        TranslationFile.pleaseFillOutTheFields[
                          userSelectedLanguage
                        ]
                      )
                    }
                    onInput={(e) => e.target.setCustomValidity("")}
                    onBlur={(e) => inputFieldsOnBlur(e, "email")}
                  />
                  <br></br>
                  <br></br>

                  <input
                    type="text"
                    name="rblContact Number"
                    placeholder={
                      TranslationFile.ContactUsNumber[userSelectedLanguage]
                    }
                    className="contact-ContactNo-User"
                    autocomplete="new-password"
                    onBlur={(e) => inputFieldsOnBlur(e, "contact")}
                  />
                  <br></br>
                  <br></br>

                  <textarea
                    name="rblmessage"
                    placeholder={
                      TranslationFile.ContactUsMessage[userSelectedLanguage]
                    }
                    className="contact-Message-User"
                    autocomplete="new-password"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        TranslationFile.pleaseFillOutTheFields[
                          userSelectedLanguage
                        ]
                      )
                    }
                    onInput={(e) => e.target.setCustomValidity("")}
                    onBlur={(e) => inputFieldsOnBlur(e, "message")}
                  ></textarea>
                  <br></br>
                  <br></br>

                  <input
                    type="file"
                    name="rblfile"
                    id="input_file"
                    onChange={handleFile}
                    className="contact-file-upload"
                    multiple
                    style={{ display: "none" }}
                    autocomplete="new-password"
                  />
                  <label
                    htmlFor="input_file"
                    className="contact_label_choosefile"
                    // style={{
                    //   cursor: 'pointer',
                    //   backgroundColor: 'white',
                    //   color: 'black',
                    //   padding: '10px 20px',
                    //   borderRadius: '5px',
                    //   marginLeft: '-32%',
                    // }}
                  >
                    {
                      TranslationFile.contactChooseFileText[
                        userSelectedLanguage
                      ]
                    }
                  </label>

                  <span>
                    {" "}
                    {file.length > 0
                      ? `${file.length} file(s) selected`
                      : TranslationFile.contactNofilesChosenText[
                          userSelectedLanguage
                        ]}
                  </span>

                  <br></br>
                  <p className="contactUsMaxUploadSize">
                    {TranslationFile.ContactUsFileSizeLbl[userSelectedLanguage]}
                    {config.ContactUs.uploadFileSizeLimit}
                    {" MB)"}
                  </p>
                </div>
              </center>
              <center>
                {submitBtnLoading ? (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "2rem" }}
                  ></i>
                ) : (
                  <>
                    <a
                      href="mailto:info@rebelskool.com"
                      onClick={(e) => e.preventDefault()}
                      style={{ display: "contents" }}
                    >
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="contact-message-submit"
                      >
                        {
                          TranslationFile.ContactUsSubmitBtn[
                            userSelectedLanguage
                          ]
                        }
                      </button>
                    </a>
                  </>
                )}
              </center>
              <br></br>
            </form>
          </div>
        </div>
      </div>
      <div>
        <FAQSection />
      </div>
    </div>
  );
}
